module.exports = __webpack_public_path__ + "static/media/unhcr-logo.a86f4715.png";